import React from "react";
import { useAuth } from "../../app/providers/AuthProvider";

// Request identity only; existing pages keep their own data and loading state.
export function useAiRequestGuard(keys = {}) {
  const state = React.useRef({alive: true, serial: {}, keys});
  state.current.keys = keys;
  React.useEffect(() => { const current = state.current; current.alive = true; return () => { current.alive = false; }; }, []);
  return React.useCallback(channel => {
    const current = state.current;
    const serial = (current.serial[channel] || 0) + 1;
    current.serial[channel] = serial;
    const key = JSON.stringify(current.keys[channel] ?? null);
    return () => current.alive && current.serial[channel] === serial && key === JSON.stringify(current.keys[channel] ?? null);
  }, []);
}

export function AiLoadError({message, onRetry, loading = false, label = "load"}) {
  return message ? <div role="alert" className="my-3 rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-800">
    <p>{message}</p><button type="button" onClick={onRetry} disabled={loading} className="mt-2 rounded border border-red-300 px-3 py-1 disabled:opacity-50">Retry {label}</button>
  </div> : null;
}

export function withAiAgentScope(Page) {
  return function ScopedAiPage(props) {
    const auth = useAuth() || {};
    const businessId = auth.effectiveBusinessId || (auth.canSelectManagedBusinessScope ? auth.selectedBusinessId : auth.businessId) || auth.business?.id;
    const userId = auth.user?.id || auth.user?.userId;
    return <Page {...props} key={`${businessId || ""}:${userId || ""}`} scope={{businessId, userId}} />;
  };
}
